import {
    useCreateTestingActionMutation,
    useDeleteTestingActionMutation,
    useTestingActionQuery,
    useUpdateTestingActionMutation,
} from './useTestingActionsQuery';
import {TestingAction} from '../types';

export const useTestingAction = (actionId?: string) => {
    const {
        data: record,
        isLoading: loading,
        refetch: fetchRecord
    } = useTestingActionQuery(actionId || '');

    const createMutation = useCreateTestingActionMutation();
    const updateMutation = useUpdateTestingActionMutation();
    const deleteMutation = useDeleteTestingActionMutation();

    const createRecord = async (values: TestingAction) => {
        return await createMutation.mutateAsync(values);
    };

    const updateRecord = async (values: TestingAction) => {
        if (typeof actionId === 'undefined') {
            throw new Error('actionId is required parameter');
        }
        return await updateMutation.mutateAsync({
                                                    id: actionId,
                                                    record: values,
                                                });
    };

    const deleteRecord = async () => {
        if (typeof actionId === 'undefined') {
            throw new Error('actionId is required parameter');
        }
        return await deleteMutation.mutateAsync(actionId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
